import { endOfDay, startOfDay, subHours } from "date-fns";
import { useMemo } from "react";

import { useRequestQuery } from "@/features/common/hooks/useRequestQuery";
import {
  JobOrderByWithRelationInput,
  JobWhereInput,
} from "@/generated/graphql-hooks";

export const useJobListWhereQuery = () => {
  const { query } = useRequestQuery<
    JobWhereInput,
    JobOrderByWithRelationInput
  >();

  return useMemo(() => {
    if (!query?.where) return null;
    return {
      ...query.where,
      ...(query.where?.createdAt?.gte && {
        createdAt: {
          lte: endOfDay(new Date()),
          gte: subHours(startOfDay(new Date()), 24 * query.where.createdAt.gte),
        },
      }),
    };
  }, [query?.where]);
};
